import { StoreRoutes } from "../../Common/Routes"
import StoreSideBar from "./StoreSideBar"
import { Route, Switch } from 'react-router'
import { motion } from 'framer-motion'
import { withRouter } from "react-router-dom"
import React, { useEffect, useState } from 'react'
import API from "../../Common/API"
import { useDispatch } from "react-redux"
import { setAccountDetails } from "../../Store/Auth/actions"

const StoreRoot = () => {

    const dispatch = useDispatch()

    useEffect(() => {
        API.get('/accounts/getAccountDetails').then((res) => {
            if (res.status === 200) {
                dispatch(setAccountDetails(res.data.data))
            }
        })
    }, [])

    return (
        <motion.div className="h-full bg-pColor flex md:flex-row flex-col">
            <StoreSideBar />
            <div className="w-full flex flex-col h-full">
                <div className="text-left overflow-auto px-1 mx-2 py-2 text-tpColor">
                    <Switch>
                        {StoreRoutes.map(c => (
                            <Route key={c.link} path={c.link} exact component={c.component} />
                        ))}
                    </Switch>
                </div>
            </div>
        </motion.div>
    )
}

export default withRouter(StoreRoot)